import LandingPage from '$lib/components/landing-pages'
import Components from '$lib/modules/cms'

type ComponentList = {
	[key: string]: {
		this: any
		props: {
			[key: string]: string
		}
	}
}

// const for setting typename strings of wrapper components
export const CONTENT_SECTION_START = 'ComponentPbLayoutSectionStart'
export const CONTENT_SECTION_END = 'ComponentPbLayoutSectionEnd'

//this is a list of all the components that are used in the page builder
//the key is the typename of the component in Strapi API
//this is reference to Svelte component
//in props the key is the name of the Svelte component prop and the value is the name of the field in Strapi
export const COMPONENT_LIST: ComponentList = {
	// LandingPage – probably will be replaced by unified PB components
	ComponentLandingPageButton: {
		this: LandingPage.Button,
		props: {
			text: 'buttonText',
			url: 'url',
			type: 'type'
		}
	},
	ComponentLandingPageTextBlock: {
		this: LandingPage.Text,
		props: {
			text: 'text'
		}
	},
	ComponentLandingPageImage: {
		this: LandingPage.Image,
		props: {
			url: 'imageField.data.attributes.url',
			alt: 'alt',
			size: 'size'
		}
	},
	ComponentLandingPageCtaBox: {
		this: LandingPage.CTABox,
		props: {
			buttons: 'button',
			text: 'text'
		}
	},
	// new PB components
	ComponentPbBoxesBoxPrimary: {
		this: Components.BoxesBoxPrimary,
		props: {
			width: 'width',
			title: 'title',
			subtext: 'subtext',
			button: 'button'
		}
	},
	ComponentPbBannersTeamBanner: {
		this: Components.BannersTeamBanner,
		props: {
			width: 'width',
			title: 'title',
			text: 'text',
			people: 'people'
		}
	},
	ComponentPbBannersImageOnly: {
		this: Components.BannersImageOnly,
		props: {
			width: 'width',
			url: 'url',
			alternativeText: 'alternativeText',
			image: 'image',
			imageMobile: 'imageMobile'
		}
	},

	ComponentPbBasicsTextBlock: {
		this: Components.BasicsTextBlock,
		props: {
			width: 'width',
			text: 'text'
		}
	},

	ComponentPbBasicsImage: {
		this: Components.BasicsImage,
		props: {
			width: 'width',
			alternativeText: 'alternativeText',
			image: 'image'
		}
	},

	ComponentPbLayoutSpace: {
		this: Components.LayoutSpace,
		props: {
			height: 'height'
		}
	},

	ComponentPbBasicsPdfViewer: {
		this: Components.BasicsPdfViewer,
		props: {
			file: 'file'
		}
	},

	ComponentPbProductsBrands: {
		this: Components.ProductsBrands,
		props: {
			title: 'title',
			subtext: 'subtext',
			deviceType: 'deviceType',
			brands: 'brands',
			width: 'width'
		}
	},

	ComponentPbBasicsHeroText: {
		this: Components.BasicsHeroText,
		props: {
			width: 'width',
			text: 'text',
			textAlign: 'textAlign'
		}
	},

	ComponentPbBoxesBox01: {
		this: Components.BoxesBox01,
		props: {
			width: 'width',
			title: 'title',
			text: 'text',
			image: 'image',
			link: 'link'
		}
	},

	ComponentPbFormsGrants01: {
		this: Components.FormsGrants01,
		props: {
			width: 'width',
			type: 'type',
			layout: 'layout'
		}
	},

	ComponentPbBasicsSeparator: {
		this: Components.BasicsSeparator,
		props: {
			width: 'width'
		}
	},

	ComponentPbBoxesBox02: {
		this: Components.BoxesBox02,
		props: {
			width: 'width',
			title: 'title',
			text: 'text',
			image: 'image',
			link: 'link',
			badge: 'badge'
		}
	},

	ComponentPbBasicsArticle01: {
		this: Components.BasicsArticle01,
		props: {
			width: 'width',
			title: 'title',
			suptext: 'suptext',
			image: 'image',
			article: 'article'
		}
	},

	ComponentPbBasicsFaq01: {
		this: Components.BasicsFaq01,
		props: {
			width: 'width',
			title: 'title',
			suptext: 'suptext',
			order: 'order',
			questions: 'questions',
			faq: 'faq',
			questionsLimit: 'questionsLimit'
		}
	},

	ComponentPbDetailsBlockBackground: {
		this: Components.DetailsBlockBackground,
		props: {
			width: 'width',
			bgType: 'bgType',
			position: 'position'
		}
	},

	ComponentPbBoxesBox03: {
		this: Components.BoxesBox03,
		props: {
			width: 'width',
			title: 'title',
			text: 'text',
			image: 'image',
			heroImage: 'heroImage',
			link: 'link',
			badge: 'badge'
		}
	},

	ComponentPbDetailsHeaderImage: {
		this: Components.HeaderImage,
		props: {
			width: 'width',
			image: 'image'
		}
	},

	ComponentPbTablesSimpleTable01: {
		this: Components.TablesSimpleTable01,
		props: {
			width: 'width',
			table: 'table'
		}
	},

	ComponentPbBoxesBox04: {
		this: Components.BoxesBox04,
		props: {
			width: 'width',
			title: 'title',
			text: 'text',
			image: 'image',
			showSeparator: 'showSeparator'
		}
	},
	ComponentPbContactsContactBox01: {
		this: Components.ContactsContactBox01,
		props: {
			width: 'width',
			title: 'title',
			buttonText: 'buttonText',
			buttonLink: 'buttonLink',
			phone: 'phone',
			phoneLink: 'phoneLink',
			email: 'email',
			emailLink: 'emailLink'
		}
	},

	ComponentPbBasicsAuthor: {
		this: Components.BasicsAuthor,
		props: {
			width: 'width',
			publishDate: 'publishDate',
			author: 'author'
		}
	},

	ComponentPbBasicsBlogView: {
		this: Components.BasicsBlogView,
		props: {
			width: 'width',
			articleLimit: 'articleLimit',
			articles: 'articles',
			categories: 'categories'
		}
	},
	ComponentPbBoxesBox05: {
		this: Components.BoxesBox05,
		props: {
			width: 'width',
			title: 'title',
			text: 'text',
			image: 'image',
			link: 'link'
		}
	},
	ComponentPbBoxesBoxGroup01: {
		this: Components.BoxesBoxGroup01,
		props: {
			width: 'width',
			boxes: 'boxes'
		}
	},
	ComponentPbCarouselsReviews01: {
		this: Components.CarouselsReviews01,
		props: {
			width: 'width',
			title: 'title',
			googlerating: 'googlerating',
			brands: 'brands',
			deviceTypes: 'deviceTypes',
			customerReviews: 'customerReviews'
		}
	},
	ComponentPbCarouselsSteps01: {
		this: Components.CarouselsSteps01,
		props: {
			width: 'width',
			title: 'title',
			suptext: 'suptext',
			steps: 'steps'
		}
	},
	ComponentPbMiscInvestors: {
		this: Components.MiscInvestors,
		props: {
			width: 'width',
			title: 'title',
			text: 'text',
			investors: 'investors'
		}
	},
	ComponentPbBoxesAboutUsBox01: {
		this: Components.BoxesAboutUsBox01,
		props: {
			width: 'width',
			suptext: 'suptext',
			title: 'title',
			text: 'text',
			phone: 'phone',
			email: 'email',
			personName: 'personName',
			personRole: 'personRole',
			image: 'image',
			imageMobile: 'imageMobile'
		}
	},
	ComponentPbBasicsBlogView01: {
		this: Components.BasicsBlogView01,
		props: {
			width: 'width',
			title: 'title',
			articleLimit: 'articleLimit',
			articles: 'articles',
			categories: 'categories'
		}
	},
	ComponentPbBasicsHeroText02: {
		this: Components.BasicsHeroText02,
		props: {
			width: 'width',
			text: 'text',
			textAlign: 'textAlign'
		}
	},
	ComponentPbBasicsButton: {
		this: Components.BasicsButton,
		props: {
			width: 'width',
			boxText: 'boxText',
			boxLink: 'boxLink',
			colour: 'colour'
		}
	},
	ComponentPbAdvisorPackageBoxes: {
		this: Components.AdvisorPackageBoxes,
		props: {
			width: 'width',
			title: 'title',
			device: 'device',
			packageLimit: 'packageLimit',
			packages: 'packages'
		}
	},
	ComponentPbBoxesLogoBoxGroup: {
		this: Components.BoxesLogoBoxGroup,
		props: {
			width: 'width',
			logos: 'logos'
		}
	}
}
